export const Bio = {
  name: "Messi II Innocent R.",
  roles: {
    en: [
      "Fullstack Developer",
      "AI Engineer",
      "Mobile Developer",
      "Cloud Enthusiast",
      "Open Source Contributor",
    ],
    fr: [
      "Développeur Fullstack",
      "Ingénieur IA",
      "Développeur Mobile",
      "Passionné Cloud",
      "Open Source",
    ],
  },
  description: {
    en: "Fullstack developer with 4+ years of experience shipping production mobile and web applications. I've built apps live on the Google Play Store from a jewelry marketplace to a digital banking solution and recently architected an AI healthcare assistant serving users across WhatsApp, Android, iOS, and Web. Currently expanding into cloud computing, AI, and Web3.",
    fr: "Développeur fullstack avec plus de 4 ans d'expérience dans le développement d'applications mobiles et web en production. J'ai développé des apps disponibles sur le Google Play Store d'une marketplace de bijoux à une solution bancaire numérique et récemment conçu un assistant IA de santé servant les utilisateurs via WhatsApp, Android, iOS et le Web. Actuellement en expansion vers le cloud, l'IA et le Web3.",
  },
  github: "https://github.com/Messi002",
  resume_en:
    "https://drive.google.com/file/d/1kU83ZqMZ5Z2QcJCCSSBfoScuDeKeUDWH/view?usp=sharing",
  resume_fr:
    "https://drive.google.com/file/d/1JkbFeZyydlpR9qiDYsGxQskCQuqo15s_/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/innocent-rostand-messi-ii-5b366b187/",
  youtube: "https://www.youtube.com/@Messi2Inno",
  twitter: "https://twitter.com/Messi2Inno",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg",
      },
      {
        name: "Next Js",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nextjs/nextjs-original.svg",
      },
      {
        name: "Vue.js",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/vuejs/vuejs-original.svg",
      },
      {
        name: "Flutter",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/flutter/flutter-original.svg",
      },
      {
        name: "HTML",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/html5/html5-original.svg",
      },
      {
        name: "CSS",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/css3/css3-original.svg",
      },
      {
        name: "JavaScript",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/javascript/javascript-original.svg",
      },
      {
        name: "TypeScript",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/typescript/typescript-original.svg",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nodejs/nodejs-original.svg",
      },
      {
        name: "Express Js",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/express/express-original.svg",
      },
      {
        name: "Laravel",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/laravel/laravel-original.svg",
      },
      {
        name: "Django",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/django/django-plain.svg",
      },
      {
        name: "GraphQL",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/graphql/graphql-plain.svg",
      },
      {
        name: "Python",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/python/python-original.svg",
      },
      {
        name: "Golang",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/go/go-original.svg",
      },
      {
        name: "Rust",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/rust/rust-original.svg",
      },
      {
        name: "PHP",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/php/php-original.svg",
      },
    ],
  },
  {
    title: "DevOps & Cloud",
    skills: [
      {
        name: "Docker",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/docker/docker-original.svg",
      },
      {
        name: "Kubernetes",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/kubernetes/kubernetes-original.svg",
      },
      {
        name: "Terraform",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/terraform/terraform-original.svg",
      },
      {
        name: "AWS",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/amazonwebservices/amazonwebservices-original-wordmark.svg",
      },
      {
        name: "Huawei Cloud",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSY8_dNM0cdxg1ZXrMUTVsjD27X6SbfjL0muQy8IVxmBw&s=10",
      },
    ],
  },
  {
    title: "Database & Tools",
    skills: [
      {
        name: "Redis",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/redis/redis-original.svg",
      },
      {
        name: "MySQL",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/mysql/mysql-original.svg",
      },
      {
        name: "PostgreSQL",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/postgresql/postgresql-original.svg",
      },
      {
        name: "MongoDB",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/mongodb/mongodb-original.svg",
      },
      {
        name: "Firebase",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/firebase/firebase-original.svg",
      },
      {
        name: "Git",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/git/git-original.svg",
      },
      {
        name: "Figma",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/figma/figma-original.svg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    role: { en: "Fullstack Developer & AI Engineer", fr: "Développeur Fullstack & Ingénieur IA" },
    company: "Waspito, Cameroon",
    date: { en: "August 2025 – July 2026", fr: "Août 2025 – Juillet 2026" },
    desc: {
      en: "Architected and deployed AHIM (Africa's Health Intelligent Model), a production AI healthcare assistant serving users across WhatsApp, Android, iOS, and Web channels, built on Laravel/PHP with Vue.js (Inertia) and Claude (Anthropic) as the LLM backbone. Designed the full agentic tool-calling architecture including prompt engineering, action-tag parsing, tool registry, and context-aware session management.",
      fr: "Conception et déploiement d'AHIM (Africa's Health Intelligent Model), un assistant de santé IA en production servant les utilisateurs via WhatsApp, Android, iOS et le Web, développé avec Laravel/PHP, Vue.js (Inertia) et Claude (Anthropic). Conception de l'architecture complète d'agent avec appels d'outils : ingénierie de prompts, analyse de balises d'action, registre d'outils et gestion de sessions contextuelles.",
    },
    skills: ["Laravel", "PHP", "Vue.js", "Claude AI", "WhatsApp API", "Python"],
    doc: "https://app.waspito.com",
  },
  {
    id: 1,
    role: { en: "Fullstack Developer", fr: "Développeur Fullstack" },
    company: "Techonsoft Inc, USA",
    date: { en: "February 2025 – April 2026", fr: "Février 2025 – Avril 2026" },
    desc: {
      en: "Developed multi-tenant architecture with isolated data and customizable workflows supporting multiple healthcare organizations. Built JWT-based authentication systems with role-based access control and integrated caching with Redis and IndexedDB for performance optimization.",
      fr: "Développement d'une architecture multi-tenant avec données isolées et flux de travail personnalisables pour plusieurs organisations de santé. Mise en place de systèmes d'authentification JWT avec contrôle d'accès basé sur les rôles et intégration de mécanismes de cache via Redis et IndexedDB.",
    },
    skills: ["Node.js", "React", "Redis", "IndexedDB", "JWT", "PostgreSQL"],
    doc: "https://www.linkedin.com/company/techonsoft-inc",
  },
  {
    id: 2,
    role: { en: "Fullstack Developer", fr: "Développeur Fullstack" },
    company: "Afrovision Group Consulting, Cameroon",
    date: { en: "July 2024 – March 2025", fr: "Juillet 2024 – Mars 2025" },
    desc: {
      en: "Developed core modules for Flexy-Pay (digital banking) and Pro4Home (job search platform) — two Flutter-based apps with Laravel/PHP backends. Implemented secure payment workflows for airtime, bills, and transfers. Built real-time matching algorithms connecting users with service providers.",
      fr: "Développement de modules principaux pour Flexy-Pay (banque numérique) et Pro4Home (plateforme d'emploi) — deux apps Flutter avec backends Laravel/PHP. Mise en œuvre de flux de paiement sécurisés et développement d'algorithmes de mise en relation en temps réel connectant les utilisateurs avec des prestataires.",
    },
    skills: ["Flutter", "Dart", "Laravel", "PHP", "Firebase", "PostgreSQL"],
    doc: "https://www.afrovisiongroup.com",
  },
  {
    id: 3,
    role: { en: "Fullstack Developer", fr: "Développeur Fullstack" },
    company: "DohTech Solutions, USA",
    date: { en: "September 2023 – May 2024", fr: "Septembre 2023 – Mai 2024" },
    desc: {
      en: "Developed Buzme Marketplace, a Flutter e-commerce platform for buying, selling, creating business cards, and real-time delivery tracking. Implemented a PostgreSQL, Redis, and Elasticsearch backend for optimized search. Used Docker containers and load balancers to manage large-scale traffic.",
      fr: "Développement de Buzme Marketplace, une plateforme e-commerce Flutter permettant d'acheter, vendre, créer des cartes de visite et suivre les livraisons en temps réel. Mise en place d'un backend PostgreSQL, Redis et Elasticsearch pour des performances de recherche optimisées avec Docker.",
    },
    skills: ["Flutter", "Node.js", "PostgreSQL", "Redis", "Elasticsearch", "Docker"],
    doc: "https://dohtechsolutions.com",
  },
  {
    id: 4,
    role: { en: "Fullstack Developer", fr: "Développeur Fullstack" },
    company: "Health Research Foundation, UK",
    date: { en: "January 2023 – January 2024", fr: "Janvier 2023 – Janvier 2024" },
    desc: {
      en: "Developed a Flutter health app for pregnant women featuring water intake reminders, prenatal visit notifications, personalized health alerts, appointment booking, and direct doctor calling. Designed data collection mechanisms for tracking pregnancy timelines and health metrics.",
      fr: "Développement d'une application de santé Flutter pour les femmes enceintes : rappels d'hydratation, notifications de visites prénatales, alertes de santé personnalisées, prise de rendez-vous et appel direct de médecin. Conception de mécanismes de collecte de données pour le suivi de grossesse.",
    },
    skills: ["Flutter", "Dart", "Firebase", "TypeScript", "Django"],
    doc: "https://www.hrfbuea.org",
  },
  {
    id: 5,
    role: { en: "Fullstack Developer", fr: "Développeur Fullstack" },
    company: "Camsol Technologies, Germany",
    date: { en: "September 2022 – December 2023", fr: "Septembre 2022 – Décembre 2023" },
    desc: {
      en: "Developed Sajent, a Flutter jewelry marketplace with a Tinder-style browsing experience. Built a TypeScript Express.js API serving jewelry data. Participated in backend development for ValletPay (online payments platform) and the Camsol training platform.",
      fr: "Développement de Sajent, une marketplace de bijoux Flutter avec une expérience de navigation style Tinder. Développement d'une API TypeScript Express.js. Participation au développement backend de ValletPay (plateforme de paiement en ligne) et de la plateforme de formation Camsol.",
    },
    skills: ["Flutter", "Dart", "TypeScript", "Express.js", "Firebase", "MongoDB"],
    doc: "https://camsol.io",
  },
];

export const education = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRNYxc8xFKKp54fY6YGhCZMW7-fUyoccllAwKl1uTXzuw&s=10",
    school: "University of Buea, Cameroon",
    date: "November 2021 – December 2025",
    grade: "Bachelor of Engineering",
    desc: "Completed Bachelor's in Computer Software Engineering at the Faculty of Engineering and Technology. Studied Data Structures, Algorithms, Software Architecture, Operating Systems, Computer Networks, and Database Management Systems.",
    degree: "Bachelor of Engineering - Software Engineering",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQqvg4b0agvc7VxmwCv0xBEF2EoxHXroDlzsWtXCUwbkQ&s",
    school: "Cameroon College of Arts and Science, Kumba",
    date: "September 2016 – July 2018",
    grade: "A-Levels",
    desc: "Pursued Advanced Levels (A-Levels) in Science, building a foundation in mathematics, physics, and analytical thinking.",
    degree: "Advanced Levels (A-Levels), Science",
  },
];

export const certifications = [
  {
    id: 0,
    title: { en: "Huawei ICT Competition Winner", fr: "Lauréat de la compétition Huawei ICT" },
    issuer: "Huawei",
    date: "2024–2025",
    desc: { en: "1st place in the Huawei ICT exam (Nationals, Douala) in the Cloud, Big Data, and AI track.", fr: "1ère place à l'examen Huawei ICT (Nationale, Douala) dans la filière Cloud, Big Data et IA." },
  },
  {
    id: 1,
    title: { en: "Cloud Service Computing Micro-Certification", fr: "Micro-certification en Cloud Service Computing" },
    issuer: "Huawei",
    date: "2024",
    desc: { en: "Trained in cloud computing architectures, networking, and security.", fr: "Formation en architectures cloud, réseaux et sécurité." },
  },
  {
    id: 2,
    title: { en: "Enterprise Design Thinking Co-Creator", fr: "Enterprise Design Thinking Co-Creator" },
    issuer: "IBM",
    date: "2023",
    desc: { en: "Learned human-centered problem-solving techniques for product development.", fr: "Apprentissage des techniques de résolution de problèmes centrées sur l'humain." },
  },
  {
    id: 3,
    title: { en: "JavaScript Mentor", fr: "Mentor JavaScript" },
    issuer: "Google Developer Group, Buea",
    date: "2023",
    desc: { en: "Mentored beginner JavaScript developers, assisting in debugging and best practices.", fr: "Encadrement de développeurs JavaScript débutants, aide au débogage et aux bonnes pratiques." },
  },
];

export const projects = [
  {
    id: 0,
    title: "Servo Web Engine (Open Source)",
    description: {
      en: "Contributed to Mozilla's Servo web engine written in Rust. Fixed rendering and memory leaks (ImageBitmap, Blob URL resolution, canvas dithering artifacts), patched layout overflow clipping bugs, fixed garbage collection issues, and updated the compiler toolchain.",
      fr: "Contributions au moteur web Servo de Mozilla écrit en Rust. Résolution de fuites de rendu et de mémoire (ImageBitmap, Blob URL, artefacts de tramage), correction de bugs de disposition et de garbage collection, mise à jour de la chaîne d'outils du compilateur.",
    },
    image: "https://servo.org/img/servo-color-negative-no-container.png",
    tags: ["Rust", "WebRender", "Open Source", "Graphics"],
    category: "open source",
    github: "https://github.com/servo/servo/pulls?q=is%3Apr+author%3AMessi002+is%3Aclosed",
  },
  {
    id: 1,
    title: "AHIM – AI Healthcare Assistant",
    description: {
      en: "Production AI assistant serving users across WhatsApp, Android, iOS, and Web. Built with Laravel/PHP, Vue.js, and Claude AI. Features agentic tool-calling architecture, multi-turn conversations, insurance fraud detection, and clinical note generation.",
      fr: "Assistant IA en production servant les utilisateurs via WhatsApp, Android, iOS et le Web. Développé avec Laravel/PHP, Vue.js et Claude AI. Architecture d'agent avec appels d'outils, conversations multi-tours, détection de fraude d'assurance et génération de notes cliniques.",
    },
    image: "https://app.waspito.com/images/logo.png",
    tags: ["Laravel", "Vue.js", "Claude AI", "WhatsApp API", "PHP"],
    category: "web app",
    webapp: "https://app.waspito.com",
  },
  {
    id: 2,
    title: "Buzme Marketplace",
    description: {
      en: "Flutter e-commerce platform for buying, selling, creating business cards, and real-time delivery tracking. Backend with PostgreSQL, Redis, and Elasticsearch for optimized search and Docker containers for scalability.",
      fr: "Plateforme e-commerce Flutter pour acheter, vendre, créer des cartes de visite et suivre les livraisons en temps réel. Backend PostgreSQL, Redis et Elasticsearch pour des recherches optimisées avec Docker.",
    },
    image: "https://play-lh.googleusercontent.com/BuVl24HdCY7F40oTRyHCWf49UAchA8UVBiRwI5TWsvcXVsGCOZS-OOpipnFLwBjdyDELMW0q9CgEYbZbrqw7sw=s48-rw",
    tags: ["Flutter", "Node.js", "PostgreSQL", "Redis", "Docker"],
    category: "android app",
    github: "https://dohtechsolutions.com",
  },
  {
    id: 3,
    title: "Flexy-Pay",
    description: {
      en: "Flutter-based banking solution with secure payment workflows for airtime purchases, bill payments, and fund transfers. Features optimized database transactions and real-time transaction processing.",
      fr: "Solution bancaire Flutter avec flux de paiement sécurisés pour les achats de crédit téléphonique, le règlement de factures et les transferts de fonds. Transactions en base de données optimisées et traitement en temps réel.",
    },
    image: "https://play-lh.googleusercontent.com/bRpi6NaHzrw53JdZ6byKplOIfGq1EEpJJmLwEfxAIvSrEh1tJrUzsYJIpvOsy7R6MOIVp3wMflHh-IgHG4ghfA=w240-h480-rw",
    tags: ["Flutter", "Laravel", "PHP", "Firebase", "PostgreSQL"],
    category: "android app",
  },
  {
    id: 4,
    title: "Sajent – Jewelry Marketplace",
    description: {
      en: "Flutter marketplace with a Tinder-style browsing experience for exploring, favoriting, and purchasing jewelry. Built with TypeScript Express.js API backend for high-speed transactions.",
      fr: "Marketplace Flutter avec navigation style Tinder pour explorer, mettre en favori et acheter des bijoux. API TypeScript Express.js pour des transactions haute performance.",
    },
    image: "https://www.pioneerlab.de/wp-content/uploads/SajentClub3-768x426.jpg",
    tags: ["Flutter", "TypeScript", "Express.js", "Firebase"],
    category: "android app",
    github: "https://github.com/Messi002",
  },
  {
    id: 5,
    title: "Rust gRPC Chat App",
    description: {
      en: "Real-time chat application built in Rust using gRPC streaming for bidirectional communication between clients and server.",
      fr: "Application de chat en temps réel en Rust utilisant le streaming gRPC pour la communication bidirectionnelle entre clients et serveur.",
    },
    image: "https://grpc.io/img/logos/grpc-icon-color.png",
    tags: ["Rust", "gRPC", "Tonic", "Tokio"],
    category: "other",
    github: "https://github.com/Messi002/Rust-Chat-App-using-gRPC-streaming",
  },
  {
    id: 6,
    title: "Plum AI Classifier",
    description: {
      en: "Machine learning classifier project for image recognition and categorization using AI/ML techniques.",
      fr: "Projet de classification par apprentissage automatique pour la reconnaissance et la catégorisation d'images.",
    },
    image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/python/python-original.svg",
    tags: ["Python", "Machine Learning", "AI"],
    category: "other",
    github: "https://github.com/Messi002/Plum-AI-Classifier",
  },
  {
    id: 7,
    title: "DjanChat",
    description: {
      en: "Real-time chat application using Django Channels and WebSockets, enabling live messaging between users with persistent message history.",
      fr: "Application de chat en temps réel utilisant Django Channels et WebSockets pour la messagerie en direct avec historique persistant.",
    },
    image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/django/django-plain.svg",
    tags: ["Django", "Python", "WebSockets", "Channels"],
    category: "web app",
    github: "https://github.com/Messi002",
  },
  {
    id: 8,
    title: "CSC Picker Plus (Open Source)",
    description: {
      en: "Opened a PR to improve csc_picker_plus, a Flutter package for Country, State, and City picker. Contributed bug fixes and feature enhancements.",
      fr: "Ouverture d'une PR pour améliorer csc_picker_plus, un package Flutter pour la sélection de pays, état et ville. Corrections de bugs et améliorations de fonctionnalités.",
    },
    image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/flutter/flutter-original.svg",
    tags: ["Flutter", "Dart", "Open Source"],
    category: "open source",
    github: "https://github.com/Messi002/csc_picker_plus",
  },
  {
    id: 9,
    title: "Snaky – Rust Snake Game",
    description: {
      en: "Classic Snake game built in Rust using SDL2 for graphics rendering and real-time user input handling.",
      fr: "Jeu Snake classique en Rust avec SDL2 pour le rendu graphique et la gestion des entrées utilisateur en temps réel.",
    },
    image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/rust/rust-original.svg",
    tags: ["Rust", "SDL2", "Game Dev"],
    category: "other",
    github: "https://github.com/Messi002/Rust_Snake_Game",
  },
  {
    id: 10,
    title: "Flutter Notes Sharing App",
    description: {
      en: "A Flutter application for creating, managing, and sharing notes between users with a clean UI and real-time sync capabilities.",
      fr: "Application Flutter pour créer, gérer et partager des notes entre utilisateurs avec une interface claire et synchronisation en temps réel.",
    },
    image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/flutter/flutter-original.svg",
    tags: ["Flutter", "Dart", "Firebase"],
    category: "other",
    github: "https://github.com/Messi002/Flutter_Notes_Sharing_App",
  },
  {
    id: 11,
    title: "Flutter Traveling App",
    description: {
      en: "A travel app UI built with Flutter, showcasing beautiful destination cards, booking flows, and REST API integration for travel data.",
      fr: "Interface d'application de voyage Flutter avec des cartes de destinations, flux de réservation et intégration d'API REST pour les données de voyage.",
    },
    image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/flutter/flutter-original.svg",
    tags: ["Flutter", "Dart", "REST API", "Cubits"],
    category: "other",
    github: "https://github.com/Messi002/Flutter-Traveling-app-",
  },
];
